"use client";

import { PlayIcon, SmileIcon } from "@hugeicons-pro/core-stroke-rounded";
import type { FC } from "react";
import ModeSelectionOption from "./ModeSelectionOption";

type Props = {
  isFunMode: boolean;
  changeMode?: (mode: "real" | "fun") => void;
};

// A single switch, not one button per mode: `changeMode` receives the mode being switched *to*.
const GameControlsMode: FC<Props> = ({ isFunMode, changeMode }) => {
  const handleClick = () => changeMode?.(isFunMode ? "real" : "fun");

  return (
    <button
      type="button"
      role="switch"
      // Both labels are always in the DOM, so aria-label must say which one aria-checked refers to.
      aria-checked={isFunMode}
      aria-label="Fun mode"
      onClick={handleClick}
      className={[
        "flex items-center rounded-full p-1 cursor-pointer",
        "bg-background",
        "outline-none focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50",
      ].join(" ")}
    >
      <ModeSelectionOption icon={PlayIcon} label="Real" isActive={!isFunMode} />
      <ModeSelectionOption icon={SmileIcon} label="Fun" isActive={isFunMode} />
    </button>
  );
};

export { GameControlsMode };
